import { Card, Table, OverlayTrigger, Tooltip, Badge } from 'react-bootstrap';
import AmiCell from './common/AmiCell';

const AmiByCountyCard = ({
  amiMap,
  amiHouseholdAdder,
  counties,
  rowCount,
  onEditAmiCell,
  onEditAmiAdder,
}) => {
  return (
    <Card className="mb-4">
      <Card.Header>
        <h5 className="mb-0">
          <span>Area Median Income (AMI) by Household Size and Washington County </span>
            <OverlayTrigger
              placement="right"
              overlay={
                <Tooltip id="arrears-liability-tooltip">
                  Hover over cells to enable edit options.
                </Tooltip>
              }
          >
            <Badge bg="secondary" pill style={{ cursor: 'help' }}>?</Badge>
          </OverlayTrigger>
        </h5>
      </Card.Header>

      <Card.Body>
        <h6>AMI by Household Size 1–{rowCount}</h6>

        <div className="table-responsive">
            <Table striped bordered>
              <thead>
                <tr>
                  <th className="text-center">Household<br/>Size</th>
                  {counties.map((county, i) => (
                    <th key={`ami-header-${county}-${i}`} className="text-center">
                      {county}
                    </th>
                  ))}
                </tr>
              </thead>

            <tbody>
              {Array.from({ length: rowCount }, (_, i) => (
                <tr key={i}>
                  <td className="text-center align-middle">{i + 1}</td>

                  {counties.map((county) => {
                      const ami = amiMap[county]?.[i];
                      if (!ami) {
                        return (
                          <td
                            key={`ami-${county}-${i}-empty`}
                            className="text-center align-middle text-muted"
                          >-</td>
                        );
                      }

                      return <AmiCell
                        key={`ami-${county}-${i}`}
                        county={county}
                        currentValue={ami.ami}
                        effectiveDate={ami.effectiveDate}
                        upcomingValue={ami.upcomingAmi?.ami}
                        upcomingEffectiveDate={ami.upcomingAmi?.effectiveDate}
                        onClick={() => onEditAmiCell(ami)}
                      />
                    })
                  }
                </tr>
              ))}
            </tbody>
          </Table>
        </div>

        <h6 className="mt-4">Adder for Additional Household Size</h6>

        <div className="table-responsive">
            <Table striped bordered>
              <thead>
                <tr>
                  <th className="text-center">Household<br/>Size</th>
                  {amiHouseholdAdder?.map((aha, i) => (
                    <th key={`ami-adder-header-${aha.county}-${i}`} className="text-center">
                      {aha.county}
                    </th>
                  ))}
                </tr>
              </thead>

            <tbody>
                <tr>
                <td className="text-center align-middle">{rowCount + 1}+</td>
                  {amiHouseholdAdder?.map((aha, i) => (
                    <AmiCell
                      key={`adder-${aha.county}-${i}`}
                      county={aha.county}
                      currentValue={aha.amiAdderPerHousehold}
                      effectiveDate={aha.effectiveDate}
                    upcomingValue={aha.upcomingAdder?.amiAdderPerHousehold}
                    upcomingEffectiveDate={aha.upcomingAdder?.effectiveDate}
                    onClick={() => onEditAmiAdder(aha)}
                  />
                ))}
              </tr>
            </tbody>
          </Table>
        </div>
      </Card.Body>
    </Card>
  );
};

export default AmiByCountyCard;